export const selectBox = () => {
  const yearSelects = document.querySelectorAll<HTMLSelectElement>('.js-select-year');

  const setDefaultOption = (selects: HTMLSelectElement[]) => {
    selects.forEach((select) => {
      const { pathname } = window.location;
      const options = select.querySelectorAll<HTMLOptionElement>('option');
      const currentOption = Array.from(options).find((option) =>
        option.value.includes(pathname.replace(/[^0-9]/g, '')),
      );

      if (currentOption) {
        currentOption.setAttribute('selected', 'true');
      } else {
        options[0].setAttribute('selected', 'true');
      }
    });
  };

  const pageTransition = (selects: HTMLSelectElement[]) => {
    selects.forEach((select) => {
      select.addEventListener('change', (e: Event) => {
        window.location.href = (e.target as HTMLSelectElement)?.value;
      });
    });
  };

  setDefaultOption(Array.from(yearSelects));
  pageTransition(Array.from(yearSelects));
};
